/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-11-29 21:07:51
 */

import React from 'react'
import addPhotosIcon from '../../images/jigsaw-examples/add_photos_icon.png'
import { useNavigate } from 'react-router-dom'
import CONFIG from '../../constants/config'
import sensors from '../../utils/sensors'
import type { JigsawPhoto, JigsawData } from './types'

interface AddPhotosProps {
  photos: JigsawPhoto[]
  jigsawData: JigsawData
}

const AddPhotos = ({ photos, jigsawData }: AddPhotosProps) => {
  const navigate = useNavigate()
  const onClick = () => {
    sensors.track('web_workgroup_jigsaw_click', {
      clickItem: 'add_photos'
    })
    localStorage.setItem('jigsaw_data_cache', JSON.stringify(jigsawData))
    navigate(
      encodeURI(
        `/photo/picker?from=jigsaw&pageTitle=选择拼图照片&mediaType=0&max=${CONFIG.jigsawMaxNum}`
      )
    )
  }

  if (!photos.length) {
    return (
      <div className="add-photos-area" onClick={onClick}>
        <img src={addPhotosIcon} />
        <span>点击此处添加拼图照片</span>
      </div>
    )
  }
  return null
}

export default AddPhotos
